/*eslint-disable*/
import { getPresentationalFiltersWithSortEnabledField } from '../../helpers/filtersHelpers';

export const setServicesFilterMiddleware = (action, state) => {
  const { fieldName } = action.payload;
  const { data, filters } = state;

  const allFilters = getPresentationalFiltersWithSortEnabledField(
    data[fieldName],
    filters[fieldName]
  );

  return {
    ...state,
    searchValues: {
      ...state.searchValues,
      [fieldName]: '',
    },
    presentationalFilters: {
      ...state.presentationalFilters,
      [fieldName]: allFilters,
    },
  };
};
